"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNodeDataReference = void 0;
/**
 * This returns whether the given item is a NodeDataReference. We decide this based on whether or not the given variable
 *  is an object with both necessary fields. This isn't guaranteed to be perfect, but it's unlikely to fail...
 * @param item NodeSource or AttributeMap
 */
const isNodeDataReference = (item) => {
    return typeof item === 'object' && item !== null && 'sourceObject' in item && 'sourcePath' in item;
};
exports.isNodeDataReference = isNodeDataReference;
//# sourceMappingURL=types.js.map